import { useService } from '@visiba/instantiation';
import { useEffect, useReducer } from 'react';
import { UnhandledIssuesService } from './unhandled_issues.service';

/**
 * Hook that taps into the UnhandledIssuesService, counting the number of issues.
 */
export function useTrackedIssue(trackingId: string, filterByTags?: string[]): number {
	const unhandledIssuesService = useService(UnhandledIssuesService);
	const [, forceUpdate] = useReducer((x) => x + 1, 0);

	useEffect(
		function whenHookIsMounted() {
			return unhandledIssuesService.onChange(() => {
				forceUpdate();
			});
		},
		[unhandledIssuesService],
	);

	useEffect(
		function whenFilterIsChanged() {
			forceUpdate();
		},
		// We might need to use something like: https://github.com/kentcdodds/use-deep-compare-effect
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[trackingId, ...(filterByTags ?? [])],
	);

	return unhandledIssuesService.getCountByIssuesById(trackingId, filterByTags);
}
